import { useEffect, useState } from "react";
import {logToClientLogger} from "../../helpers/clientLogger";

const firstKey = (obj) => (obj && Object.keys(obj)[0]) || "";
const defaultScreensConfig = {
  "x-small": "(max-width: 479px)",  // firstKey is the defaultScreen
  "small": "(max-width: 767px) and (min-width: 480px)",
  "medium": "(max-width: 1199px) and (min-width: 768px)",
  "large": "(min-width: 1200px)"
};

const getInitialMatch = (screens = defaultScreensConfig, defaultScreen = firstKey(screens)) => {  
  for (const [screen, mQuery] of Object.entries(screens)) {
    if (window.matchMedia(mQuery).matches) {
      return screen;
    }
  }

  return defaultScreen;
};

export default function useMediaQuery(screensConfig = defaultScreensConfig, defaultScreen) {
  const [deviceScreen, setDeviceScreen] = useState(getInitialMatch(screensConfig, defaultScreen));
  const setListner = (screen, mquery) => () => {
    if (window.matchMedia(mquery).matches) {
      setDeviceScreen(screen);
    }
  };

  useEffect(() => {
    const listners = {};
    const mqls = {};

    for (const [screen, mQuery] of Object.entries(screensConfig)) {
      listners[screen] = setListner(screen, mQuery);
      mqls[screen] = window.matchMedia(mQuery);
      mqls[screen].addListener(listners[screen]);
    }

    return () => {
      try {
        // Clean Up
        for ( const key of Object.keys(mqls)) {
          mqls[key].removeListener(listners[key]);
        }
      } catch (err) {
        logToClientLogger(err); 
      }
    };
  }, [screensConfig]);

  return { 
    deviceScreen,
    deviceScreens: screensConfig
  };
}